import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '@/core/api/request-builder';
import { StrictHttpResponse } from '@/core/api/strict-http-response';
import { ConsultorioPrivadoCreateRequest, ConsultorioPrivadoResponse } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-privado.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { SICOM_PATHS } from 'src/sicom-paths';

export function inserirConsultorioPrivado(http: HttpClient, rootUrl: string, pessoa: Pessoa, body: ConsultorioPrivadoCreateRequest, context?: HttpContext): Observable<StrictHttpResponse<ConsultorioPrivadoResponse>> {
    const rb = new RequestBuilder(rootUrl, inserirConsultorioPrivado.PATH, 'post');

    if (pessoa) {
        rb.query('id', pessoa.id, {});
        rb.query('uf', pessoa.uf, {});
    }
    if (body) {
        rb.body(body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>): StrictHttpResponse<ConsultorioPrivadoResponse> => r as unknown as StrictHttpResponse<ConsultorioPrivadoResponse>)
    );
}

inserirConsultorioPrivado.PATH = SICOM_PATHS.registro.medico.consultorioPrivado.base;
